export default __webpack_public_path__ + "static/media/profile.9a7a36ec.jpg";